import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Derive AI context filters from current route (buy / rent / resale + property kind).
 * @returns {{ property_type?: 'apartment' | 'villa' | 'plot', listing_type?: 'buy' | 'rent' | 'resale' }}
 */
export function useAiRouteFilters() {
  const location = useLocation();

  return useMemo(() => {
    const path = location.pathname.toLowerCase();
    const qs = new URLSearchParams(location.search);
    const typeParam = String(qs.get("type") || "").toLowerCase();

    let listing_type = "buy";
    let property_type = "apartment";

    if (path.includes("/rents") || path.startsWith("/rent-")) {
      listing_type = "rent";
    } else if (path.includes("resale")) {
      listing_type = "resale";
    }

    if (
      path.includes("villa") ||
      typeParam.includes("villa")
    ) {
      property_type = "villa";
    } else if (
      path.includes("plot") ||
      typeParam.includes("plot")
    ) {
      property_type = "plot";
    }

    return { property_type, listing_type };
  }, [location.pathname, location.search]);
}

export default useAiRouteFilters;
